<template lang="pug">
  table#tbInventariosFisicos.table.is-responsive.is-striped.is-narrow
    thead
      tr
        th(colspan=3 align="center") Producto Entregado
      tr
        th(align="center") Cliente
        th(align="center") T.M.
        th(align="center") # A/T's
    tbody
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  {{ verPropangol ? 'Propangol' : 'TexMex'}}
        td(align="center") 
          span.tag.is-light.is-size-6.has-text-weight-medium {{ verPropangol ? data.masaProp : data.masaTexMex | numberFormatDecimal}}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium {{ verPropangol ? data.atProp : data.atTexMex }}
      tr
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  Movernery
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  {{ data.masaMov | numberFormatDecimal}}
        td(align="center")
          span.tag.is-light.is-size-6.has-text-weight-medium  {{ data.atMov }}
      tr
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  TOTAL
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  {{ data.masaTotal | numberFormatDecimal }}
        td(align="center")
          span.tag.is-black.is-size-6.has-text-weight-medium  {{ data.atTot }}
</template>

<script>
  import moment from 'moment'

  export default {
    name: 'TbProductoEntregado',
    props: {
      data: {
        type: Object,
        default: () => {},
      },
      fecha: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        verPropangol: false,
      }
    },
    watch: {
      fecha() {
        this.verPropangol = moment(this.fecha).isBefore('2021-08-20')
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/sca_Componentes/irge/dashboard/componentes/Tb_ProductoEntregado.vue